module.exports = __webpack_public_path__ + "static/complete-f44511970a2a328cce3d8f3cda1f7fd1.png";